import React, { FunctionComponent } from 'react';
import { Colors, Theme } from '@inplayer-org/inplayer-ui';
import { transparentize } from 'polished';
import styled, { StyledComponent } from 'styled-components';
import { ifProp } from 'styled-tools';
import { FaAngleDown } from 'react-icons/fa';

// data
import { light, dark } from 'data/themes';

const FooterContainer = styled.footer<{ isDarkModeEnabled?: boolean }>`
  font-size: ${({ theme }) => theme.font.sizes.extraSmall};
  padding: 2vh 4%;
  background: ${({ isDarkModeEnabled }) =>
    isDarkModeEnabled ? dark.palette.background.main : light.palette.background.main};
  border-top: 1px solid ${Colors.gray};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 2px;
  margin: 0;
  display: flex;
  justify-content: space-between;
`;

interface ProgressLineProps {
  active?: boolean;
  backgroundColor?: string;
}

const ProgressLine: StyledComponent<'div', Theme, ProgressLineProps> = styled.div`
  height: 2px;
  background-color: ${({ backgroundColor }: ProgressLineProps) =>
    ifProp('active', backgroundColor || Colors.skyBlue, Colors.gray)};
  margin-right: 2px;
  display: block;
  width: 50%;
`;

const FooterLabel = styled.label<{ isDarkModeEnabled?: boolean }>`
  border-radius: 2px;
  color: ${({ isDarkModeEnabled }) =>
    isDarkModeEnabled ? dark.palette.text.main : transparentize(0.45, light.palette.text.main)};
  display: inline-flex;
  align-items: center;
`;

const FooterTextContainer = styled.span<{ isDarkModeEnabled?: boolean }>`
  color: ${({ isDarkModeEnabled }) =>
    isDarkModeEnabled ? dark.palette.text.main : transparentize(0.45, light.palette.text.main)};
`;

const BrandedContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const BrandImage = styled.img`
  width: 25px;
  height: 25px;
`;

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 5rem;
`;

const StyledIcon = styled(FaAngleDown)`
  width: 1rem;
  height: 1rem;
`;

interface Props {
  backgroundColor?: string;
  isDarkModeEnabled?: boolean;
}

const Footer: FunctionComponent<Props> = ({ backgroundColor, isDarkModeEnabled }) => {
  return (
    <>
      <ProgressBar>
        <ProgressLine active backgroundColor={backgroundColor} />
        <ProgressLine />
        <ProgressLine />
      </ProgressBar>
      <FooterContainer isDarkModeEnabled={isDarkModeEnabled}>
        <DetailsContainer>
          <FooterLabel isDarkModeEnabled={isDarkModeEnabled}>
            EN
            <StyledIcon />
          </FooterLabel>
          <FooterTextContainer isDarkModeEnabled={isDarkModeEnabled}>MORE</FooterTextContainer>
        </DetailsContainer>
        <BrandedContainer>
          <FooterTextContainer isDarkModeEnabled={isDarkModeEnabled}>Protected by</FooterTextContainer>
          <BrandImage src="https://assets.inplayer.com/images/inplayer_icon-fs.png" alt="logo" />
        </BrandedContainer>
      </FooterContainer>
    </>
  );
};

export default Footer;
